<template>
  <nav>
    <!--Success Snackbar -->

    <v-snackbar v-model="snackbarSuccess" :timeout="4000" top color="success">
      <span>{{message}}</span>
      <v-btn flat color="white--text" @click="snackbarSuccess = false">Chiudi</v-btn>
    </v-snackbar>

    <!--Error Snackbar -->

    <v-snackbar v-model="snackbarError" :timeout="0" top color="error">
      <span>{{message}}</span>
      <v-btn flat color="white--text" @click="snackbarError = false">Chiudi</v-btn>
    </v-snackbar>

    <!-- Toolbar -->

    <v-toolbar dark flat app class="blue darken-3">
      <v-toolbar-side-icon
        class="hidden-md-and-up"
        @click="drawer = !drawer"
        v-if="isUserAthenticated"
      ></v-toolbar-side-icon>
      <v-toolbar-title v-if="isUserAthenticated">
        <router-link to="/home" tag="span" style="cursor: pointer">PONSportivo</router-link>
      </v-toolbar-title>
      <v-toolbar-title v-if="!isUserAthenticated">
        PONSportivo
      </v-toolbar-title>
      <v-spacer></v-spacer>
      <v-toolbar-items class="hidden-sm-and-down" v-if="isUserAthenticated">
        <v-btn flat router :to="'/home'">
          <v-icon left dark>home</v-icon>Home
        </v-btn>
      </v-toolbar-items>

      <v-toolbar-items class="hidden-sm-and-down" v-if="isUserAthenticated">
        <v-btn flat router :to="'/courses'">
          <v-icon left dark>school</v-icon>Corsi
        </v-btn>
      </v-toolbar-items>

      <v-toolbar-items class="hidden-sm-and-down" v-if="isUserAdmin">
        <v-btn flat router :to="'/courseTypes'">
          <v-icon left dark>turned_in</v-icon>Tipi Corso
        </v-btn>
      </v-toolbar-items>

      <v-toolbar-items class="hidden-sm-and-down" v-if="isUserAdmin">
        <v-btn flat router :to="'/users'">
          <v-icon left dark>people</v-icon>Utenti
        </v-btn>
      </v-toolbar-items>

      <v-toolbar-items class="hidden-sm-and-down" v-if="isUserAthenticated">
        <v-btn flat @click="logout()">
          <v-icon left dark>exit_to_app</v-icon>Logout
        </v-btn>
      </v-toolbar-items>
    </v-toolbar>

    <!-- Drawer -->

    <v-navigation-drawer v-model="drawer" temporary app class="primary">
      <v-list>
        <v-list-tile router :to="'/home'" v-if="isUserAthenticated">
          <v-list-tile-action>
            <v-icon class="white--text">home</v-icon>
          </v-list-tile-action>
          <v-list-tile-content>
            <v-list-tile-title class="white--text">Home</v-list-tile-title>
          </v-list-tile-content>
        </v-list-tile>

        <v-list-tile router :to="'/courses'" v-if="isUserAthenticated">
          <v-list-tile-action>
            <v-icon class="white--text">school</v-icon>
          </v-list-tile-action>
          <v-list-tile-content>
            <v-list-tile-title class="white--text">Corsi</v-list-tile-title>
          </v-list-tile-content>
        </v-list-tile>

        <v-list-tile router :to="'/courseTypes'" v-if="isUserAdmin">
          <v-list-tile-action>
            <v-icon class="white--text">turned_in</v-icon>
          </v-list-tile-action>
          <v-list-tile-content>
            <v-list-tile-title class="white--text">Tipi Corso</v-list-tile-title>
          </v-list-tile-content>
        </v-list-tile>

        <v-list-tile router :to="'/users'" v-if="isUserAdmin">
          <v-list-tile-action>
            <v-icon class="white--text">people</v-icon>
          </v-list-tile-action>
          <v-list-tile-content>
            <v-list-tile-title class="white--text">Utenti</v-list-tile-title>
          </v-list-tile-content>
        </v-list-tile>

        <v-list-tile @click="logout()" v-if="isUserAthenticated">
          <v-list-tile-action>
            <v-icon class="white--text">exit_to_app</v-icon>
          </v-list-tile-action>
          <v-list-tile-content>
            <v-list-tile-title class="white--text">Logout</v-list-tile-title>
          </v-list-tile-content>
        </v-list-tile>
      </v-list>
    </v-navigation-drawer>
  </nav>
</template>

<script>
import { bus } from "../main";
export default {
  data() {
    return {
      drawer: false,
      user: {},
      ruolo: "",
      snackbarSuccess: false,
      snackbarError: false,
      message: ""
    };
  },
  watch: {
    snackbarSuccess() {
      if (this.snackbarSuccess && this.snackbarError) {
        this.snackbarError = false;
      }
    },
    snackbarError() {
      if (this.snackbarError && this.snackbarSuccess) {
        this.snackbarSuccess = false;
      }
    }
  },
  methods: {
    logout() {
      if (confirm("Effettuare il Logout dall'applicazione?")) {
        this.$store.dispatch("logout").then(() => {
          this.$router.push("/login");
        });
      }
    }
  },
  computed: {
    isUserAthenticated() {
      return (
        this.$store.getters.getUserLoged !== null &&
        this.$store.getters.getUserLoged !== undefined
      );
    },
    isUserAdmin() {
      return this.$store.getters.getRole === "Admin";
    }
  },
  created() {
    bus.$on("successfullOperation", data => {
      this.message = data;
      this.snackbarSuccess = true;
    });

    bus.$on("errorOperation", data => {
      this.message = data;
      this.snackbarError = true;
    });
  }
};
</script>

